{
  "label": {
    "addUser": "Add User",
    "cancel": "Cancel",
    "clearFilter": "Clear filter",
    "delete": "Delete",
    "errorDeleting": "An error occurred while deleting.",
    "errorHeader": "Error",
    "invalidData": "Invalid data",
    "manageUserFields": "Manage User Fields",
    "onboardingMailError": "An error occurred while sending the onboarding mail.",
    "onboardingMailSent": "The onboarding mail was sent successfully.",
    "save": "Save",
    "search": "Search",
    "sendOnboardingMail": "Send onboarding mail",
    "successfullyDeleted": "The entry was successfully deleted.",
    "successfullyDeletedHeader": "Successfully deleted",
    "successHeader": "Success"
  },
  "message": {
    "noUserData": "No user data available."
  },
  "user": {
    "create": "Create User",
    "createFailed": "Failed to create user.",
    "created": "User created successfully.",
    "deleteConfirmMessage": "Are you sure you want to delete this user?",
    "deleteHeader": "Delete User",
    "edit": "Edit User",
    "updateFailed": "Failed to update user.",
    "updated": "User updated successfully."
  }
}